import React, { useContext } from 'react';
import {
	TableContainer,
	Paper,
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	TableSortLabel,
	useTheme,
} from '@mui/material';
import Pagination from '@mui/material/Pagination';
import SessionContext from '../../../../contexts/SessionContext';

const ContributorsTable = (props) => {
	const theme = useTheme();
	const order = props.order || 'desc';
	const orderBy = props.orderBy || 'id';

	let { hasRole } = useContext(SessionContext);
	const isAdmin = hasRole(['CONTRIBUTORS_WRITE']);
	const canRead = isAdmin || hasRole(['CONTRIBUTORS_READ']);

	const h = props.headers_table || [];

	// Colunas base (rotulos vindos das traducoes; ordenaveis conforme o backend permite)
	const baseColumns = [
		{ field: 'name', label: h[0] || 'Nome', sortable: true },
		{ field: 'artist_name', label: h[1] || 'Nome Artístico', sortable: true },
		{ field: 'document', label: h[2] || 'Documento', sortable: true },
	];

	// Colunas bancarias/beneficiario (dados sensiveis) -> apenas admin (que recebe esses campos)
	const bankColumns = [
		{ field: 'beneficiary_name', label: h[3] || 'Beneficiário' },
		{ field: 'beneficiary_document', label: h[4] || 'CPF/CNPJ Benef.' },
		{ field: 'bank_code', label: h[5] || 'Banco' },
		{ field: 'bank_agency', label: h[6] || 'Agência' },
		{ field: 'bank_account', label: h[7] || 'Conta' },
		{ field: 'bank_account_digit', label: h[8] || 'Dígito' },
		{ field: 'bank_account_type', label: h[9] || 'Tipo de Conta' },
	];

	const columns = isAdmin ? [...baseColumns, ...bankColumns] : baseColumns;

	const handleRequestSort = (property) => {
		if (!props.onSortChange) return;
		const isAsc = orderBy === property && order === 'asc';
		props.onSortChange(property, isAsc ? 'desc' : 'asc');
	};

	return (
		<>
			<TableContainer className='table-container' component={Paper}>
				<Table
					size='small'
					aria-label='collapsible table'
					className='basic-table'
				>
					<TableHead className='basic-table-head'>
						<TableRow>
							{columns.map((col, key) => (
								<TableCell
									key={key}
									align='center'
									sortDirection={
										orderBy === col.field ? order : false
									}
								>
									{col.sortable ? (
										<TableSortLabel
											active={orderBy === col.field}
											direction={
												orderBy === col.field
													? order
													: 'asc'
											}
											onClick={() =>
												handleRequestSort(col.field)
											}
											sx={{
												'&.Mui-active': {
													color: theme.palette
														.secondary.main,
												},
												'& .MuiTableSortLabel-icon': {
													color:
														orderBy === col.field
															? `${theme.palette.secondary.main} !important`
															: 'rgba(255, 255, 255, 0.54)',
												},
												'&:hover': {
													color: theme.palette
														.secondary.light,
												},
												'&:hover .MuiTableSortLabel-icon':
													{
														color: `${theme.palette.secondary.light} !important`,
													},
												color:
													orderBy === col.field
														? theme.palette
																.secondary.main
														: 'inherit',
											}}
										>
											{col.label}
										</TableSortLabel>
									) : (
										col.label
									)}
								</TableCell>
							))}
						</TableRow>
					</TableHead>

					<TableBody>
						{props.contributors?.length > 0 && canRead
							? props.contributors.map((contributor) => (
									<TableRow className='row' key={contributor.id}>
										{columns.map((col, key) => (
											<TableCell
												key={key}
												align='center'
												className={isAdmin ? ' clickable' : ''}
												onClick={
													isAdmin
														? () =>
																props.showContributorForm(
																	contributor
																)
														: undefined
												}
											>
												{contributor[col.field]}{' '}
											</TableCell>
										))}
									</TableRow>
							  ))
							: null}
					</TableBody>
				</Table>
			</TableContainer>
			<Pagination
				shape='rounded'
				className='table-pagination'
				count={props.pages}
				page={props.current_page}
				onChange={(e, value) => {
					props.onPageChange(value);
				}}
			/>
		</>
	);
};

export default ContributorsTable;
